<svg:rect
  [attr.width]="width"
  [attr.height]="height"
  [attr.rx]="em"
  [attr.fill]="node.color"
  [attr.stroke]="node.borderColor"
  [attr.data-testid]="'directus-node-rect'"
  ></svg:rect>

  <svg
    width="24"
    height="24"
    viewBox="0 0 40 32"
    x="4"
    y="8"
    [attr.data-testid]="'directus-node-logo-container'"
    >
    <svg:use
      href="/assets/directus.svg#logo"
      y="0"
      x="0"
      [attr.data-testid]="'directus-node-logo'"
      />
  </svg>

  <svg:text
    class="name"
    [attr.x]="2 * em"
    [attr.y]="0.25 * em"
    [style.font-size.px]="em"
    alignment-baseline="text-before-edge"
    text-anchor="start"
    [attr.fill]="node.frontColor"
    [attr.data-testid]="'directus-node-name'"
    >
    {{ node?.display }}
    </svg:text>

    <svg:g
      class="junction"
      [index]="0"
      [dx]="0"
      [dy]="1 * em"
      type="input"
      [color]="node.borderColor"
      [node]="node"
      [attr.data-testid]="'directus-node-input-junction'"
      ></svg:g>

      <svg:g
        class="junction"
        [index]="1"
        [dx]="width"
        [dy]="1 * em"
        type="output"
        [color]="node.borderColor"
        [node]="node"
        [attr.data-testid]="'directus-node-output-junction'"
        ></svg:g>

        @if (!node.isAsync) {
          <svg:g
            class="conditions"
            [attr.data-testid]="'directus-node-conditions'"
            >
            <svg:g
              class="condition"
              [index]="2"
              [y]="1"
              text="異常"
              i18n-text="異常"
              [attr.data-testid]="'directus-node-error-condition'"
              ></svg:g>
              </svg:g>
            }
